import React from 'react'
import { Container } from 'reactstrap'
import styled from 'styled-components'

const Section = styled.section`
  padding: 5rem 0 3rem;
  text-align: center;
  overflow: hidden;
`

const SectionTitle = styled.h2`
  margin-bottom: 5rem;
  font-size: 2rem;
  /* font-size: 2rem; */
  /* &:after,
  &:before {
    content: '';
    position: relative;
    top: -11px;
    display: inline-block;
    width: 100%;
    height: 100%;
    border-bottom: 1px solid #fff;
  }
  &:after {
    left: 10px;
    margin-right: -100%;
  }
  &:before {
    left: -10px;
    margin-left: -100%;
  } */
  @media (max-width: 768px) {
    font-size: 2rem;
    /* &&&:before,
    &&&:after {
      display: none;
      display: none;
      content: none;
    } */
  }
`

const SectionDescription = styled.div`
  font-size: 2rem;
  line-height: 35px;
  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`

const TextSection = ({
  title,
  description,
  children,
  withoutContainer,
  ...props
}) => {
  const Cont = withoutContainer ? React.Fragment : Container
  return (
    <Section {...props}>
      <Cont>
        {title && <SectionTitle>{title}</SectionTitle>}
        {description && (
          <SectionDescription
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        {children}
      </Cont>
    </Section>
  )
}

TextSection.defaultProps = {
  withoutContainer: false,
}

export default TextSection
